import { Component, OnInit, ChangeDetectorRef } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { FormGroup } from '@angular/forms'

import { zip } from 'rxjs'

import { PassengerService } from 'app/passengers/passenger.service'
import { ReservationService } from 'app/shared/reservation/reservation.service'
import { SnapshotService } from 'app/shared/snapshot.service'
import { Passenger } from 'app/passengers/passengers.models'
import { AmendService } from 'app/shared/reservation/amend.service'
import { ResourceService } from 'app/shared/resources/resource.service'
import { hashObject } from 'app/shared/utils'
import { IPassenger } from 'app/shared/models/reservation.interfaces'
import { IInputPassengers } from 'app/passengers/passengers/passengers.component'
import { LayoutState } from 'app/shared/layout/layout-state'
import { TrackingService } from 'app/shared/tracking/tracking.service'
import { TrackingAmendmentStep } from 'app/shared/tracking/tracking-wire.interfaces'

@Component({
    selector: 'sbw-amendment-passengers',
    templateUrl: './amendment-passengers.component.html',
    styleUrls: ['./amendment-passengers.component.css']
})
export class AmendmentPassengersComponent implements OnInit {

    originalPassengers: Passenger[]
    reservationCode: string
    errors: string[] = []
    isAgent: boolean

    inputPassengers: IInputPassengers
    passengerForm: FormGroup
    public passengersChanged: boolean = false
    private initialMd5
    private selections

    constructor(
        private passengerService: PassengerService,
        private reservationService: ReservationService,
        private snapshotService: SnapshotService,
        private route: ActivatedRoute,
        private amendService: AmendService,
        private resourceService: ResourceService,
        private router: Router,
        private title: Title,
        private layoutState: LayoutState,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.isAgent = localStorage.getItem('sbw_AgentGenericId') ? true : false;
        this.passengerForm = new FormGroup({})

        this.reservationCode = this.route.snapshot.params['reservationCode']
        this.reservationService.getReservation(this.reservationCode).subscribe(reservation => {
            let { salesOwnerId, locale, routeCode } = reservation
            this.resourceService.loadResources(routeCode, locale, ['Common', 'Amendment', 'Passengers', 'AdditionalInformation'].concat(this.isAgent ? ['Agent', 'MenuAgent'] : []))
            this.resourceService.get('PASSENGERS_TITLE', false).subscribe(s => this.title.setTitle(s))
            zip(this.passengerService.getTitles('' + salesOwnerId, locale), this.passengerService.getCountries(locale)).subscribe(data => {
                const [titles, countries] = data
                this.inputPassengers = {
                    reservation: reservation,
                    form: this.passengerForm,
                    titles, // Move this to passenger component, and fetch by itself?
                    countries // Move this to passenger component, and fetch by itself?
                }
                this.layoutState.setIsContentLoaded(true)
            })
           // this.waitForFormCompletion()
            this.trackingService.trackAmendment(TrackingAmendmentStep.PASSENGERS, false, reservation)
        })
    }
    //##TODO: Should be refactored
    // waitForFormCompletion() { // Listen for when form is completly created
    //     this.passengerForm.valueChanges.subscribe(() => {
    //         if (!this.initialMd5 && this.passengerForm.get('passengers').value.length == this.inputPassengers.reservation.passengers.length) {
    //             this.selections = this.passengerForm.get('passengers').value
    //             this.initialMd5 = hashObject(this.selections)
    //         }
    //         if (this.initialMd5) {
    //             this.passengersChangedHandler()
    //             this.cdRef.detectChanges();
    //         }
    //     })
    // }

    public passengersChangedHandler() {
        this.selections = this.passengerForm.get('passengers').value
        this.passengersChanged = hashObject(this.selections) !== this.initialMd5
    }

    continue() {
        this.layoutState.setIsContentLoaded(false)
        const passengers = <IPassenger[]>this.passengerForm.get('passengers').value
        this.amendService.changePassengers(this.reservationCode, passengers).subscribe(response => {
            // If there are errors then halt & catch fire
            if (response.errorMsgs && response.errorMsgs.length) {
                this.errors = response.errorMsgs.map(m => m.message)
                this.layoutState.setIsContentLoaded(true)
                return
            }

            this.snapshotService.setSnapshot(this.reservationCode, { passengers: response.reservation.passengers })
            this.navigateBack()
        })
    }
    navigateBack() {
        this.router.navigate(['/amendment/booking', this.reservationCode])
    }
}
